const initialState = {
  shifts: [],
  loading: false,
  error: null,
};

export default function shiftReducer(state = initialState, action) {
  switch (action.type) {
    case "FETCH_SHIFTS_REQUEST":
      return { ...state, loading: true, error: null };
    case "FETCH_SHIFTS_SUCCESS":
      return { ...state, shifts: action.payload, loading: false, error: null };
    case "FETCH_SHIFTS_FAILURE":
      return { ...state, loading: false, error: action.payload };
    case "POST_SHIFT_REQUEST":
      return { ...state, loading: true, error: null };
    case "POST_SHIFT_SUCCESS":
      return { ...state, loading: false, error: null };
    case "POST_SHIFT_FAILURE":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}